import IPropertyInfo from "../../../components/shared/PropertiesMap/iPropertyInfo";

export default class BuildingDirectoryInfo implements IPropertyInfo {
    id: string = '';
    lat: number = 0;
    lon: number = 0;
    nla: number | null = null;

    private ps: string | null = null;
    get primarySector(): string | null {
        return this.ps;
    }

    private pn: string | null = null;
    get propertyName(): string | null {
        return this.pn;
    }

    private pa: string | null = null;
    get propertyAddress(): string | null {
        return this.pa;
    }

    private yb: number | null = null;
    get yearBuilt(): number | null {
        return this.yb;
    }

    private lt: string | null = null;
    get landTenure(): string | null {
        return this.lt;
    }

    private la: number | null = null;
    get landArea(): number | null {
        return this.la;
    }

    private pp: number | null = null;
    get parkingPlaces(): number | null {
        return this.pp;
    }

    private ss: string | null = null;
    get secondarySector(): string | null {
        return this.ss;
    }

    private te: string | null = null;
    get tenancy(): string | null {
        return this.te;
    }

    private pic: string | null = null;
    get photo(): string | null {
        return this.pic;
    }

    constructor(data?: any) {
        if (data) {
            this.setData(data);
        }
    }

    setData(data: any, nullString?: string | undefined): void {
        const getValue = (...keys: string[]) => {
            for (const key of keys) {
                const value = data[key];
                if (value !== undefined) {
                    if (nullString && value === nullString) {
                        return null;
                    }
                    return value;
                }
            }
            return undefined;
        };

        this.id = getValue('id', 'Id') || '';
        this.lat = Number(getValue('lat', 'Lat')) || 0;
        this.lon = Number(getValue('lon', 'Lon')) || 0;
        this.nla = getValue('nla', 'Nla') ?? null;

        this.ps = getValue('ps', 'primarySector', 'PrimarySector') ?? null;
        this.pn = getValue('pn', 'propertyName', 'PropertyName') ?? null;
        this.pa = getValue('pa', 'propertyAddress', 'PropertyAddress', 'address', 'Address') ?? null;
        this.yb = getValue('yb', 'yearBuilt', 'YearBuilt') ?? null;
        this.lt = getValue('lt', 'landTenure', 'LandTenure') ?? null;
        this.la = getValue('la', 'landArea', 'LandArea') ?? null;
        this.pp = getValue('pp', 'parkingPlaces', 'ParkingPlaces') ?? null;
        this.ss = getValue('ss', 'secondarySector', 'SecondarySector') ?? null;
        this.te = getValue('te', 'tenancy', 'Tenancy') ?? null;
        this.pic = getValue('pic', 'photo', 'Photo') ?? null;
    }
}